import * as Yup from 'yup';

export const sortPrioritySchema = Yup.object().shape({
  values: Yup.object().required('Выберите значение'),
  sortPriority: Yup.number().min(1).required(),
});
